import {
  ExclamationCircleIcon,
  TrashIcon,
  XMarkIcon,
} from "@heroicons/react/20/solid";
import axios from "axios";
import React, { useState } from "react";
import { toast } from "react-toastify";
import { Tooltip } from "react-tooltip";
import { useToast } from "../../context/ToastProvider";

function DeleteConfirmation({ id_crypt, apiType, fetchClientData, type }) {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [currentProjectId, setCurrentProjectId] = useState(null);
  const [dialogForTransaction, setDialogForTransaction] = useState(false);
  const [employeesDataList, setEmployeesDataList] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const { triggerToast } = useToast();
  const openDialog = (id_crypt) => {
    setCurrentProjectId(id_crypt);
    setIsDialogOpen(true);
  };

  const closeDialog = () => {
    setIsDialogOpen(false);
    setCurrentProjectId(null);
  };

  const handleDeleteForTask = async () => {
    setIsDialogOpen(false);
    const token = localStorage.getItem("token");
    try {
      let endpoint = "";
      if (apiType === "customer") {
        endpoint = `public/api/admin/customer/delete/${currentProjectId}`;
      } else if (apiType === "lead") {
        endpoint = `public/api/leads/${currentProjectId}`;
      } else if (apiType === "typeOfWork") {
        endpoint = `public/api/type-of-works/${currentProjectId}`;
      } else if (apiType === "AdvertisementMode") {
        endpoint = `public/api/advertisement-mode/${currentProjectId}`;
      } else if (apiType === "City") {
        endpoint = `public/api/cities/${currentProjectId}`;
      } else if (apiType === "LostReasonList") {
        endpoint = `public/api/loss-reasons/${currentProjectId}`;
      } else if (apiType === "QuoteLostReason") {
        endpoint = `public/api/quotation-loss-reasons/${currentProjectId}`;
      }else if (apiType === "priority") {
        endpoint = `public/api/priorities/${currentProjectId}`;
      }else if (apiType === "salesOrderStatus") {
        endpoint = `public/api/sales-orders-status/${currentProjectId}`;
      }else if (apiType === "worker") {
        endpoint = `public/api/workers/${currentProjectId}`;
      }else if (apiType === "project-manager") {
        endpoint = `public/api/project-manager/${currentProjectId}`;
      }else if (apiType === "salesman") {
        endpoint = `public/api/salesmen/${currentProjectId}`;
      }


      const response = await axios.delete(endpoint, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      if (response.data.branch?.branch_delete_status === 1) {
        setDialogForTransaction(true);
        setErrorMessage(response.data.message);
      } else if (response.data.product?.delete_status === 1) {
        setDialogForTransaction(true);
        setErrorMessage(response.data.message);
      } else {
        setDialogForTransaction(false);
        toast.success(response.data.message);
      }

      triggerToast("success", "Deleted Successfully", "error");

      if (apiType === "customer" && typeof fetchClientData === "function") {
        await fetchClientData();
      }
      if (apiType === "lead" && typeof fetchClientData === "function") {
        await fetchClientData();
      }

      if (apiType === "typeOfWork" && typeof fetchClientData === "function") {
        await fetchClientData();
      }

      if (
        apiType === "AdvertisementMode" &&
        typeof fetchClientData === "function"
      ) {
        await fetchClientData();
      }

      if (apiType === "City" && typeof fetchClientData === "function") {
        await fetchClientData();
      }
      if (
        apiType === "LostReasonList" &&
        typeof fetchClientData === "function"
      ) {
        await fetchClientData();
      }

      if (
        apiType === "QuoteLostReason" &&
        typeof fetchClientData === "function"
      ) {
        await fetchClientData();
      }
      if (
        apiType === "priority" &&
        typeof fetchClientData === "function"
      ) {
        await fetchClientData();
      }

      if (
        apiType === "salesOrderStatus" &&
        typeof fetchClientData === "function"
      ) {
        await fetchClientData();
      }
      if (
        apiType === "worker" &&
        typeof fetchClientData === "function"
      ) {
        await fetchClientData();
      } 
      if (
        apiType === "project-manager" &&
        typeof fetchClientData === "function"
      ) {
        await fetchClientData();
      } 
      if (
        apiType === "salesman" &&
        typeof fetchClientData === "function"
      ) {
        await fetchClientData();
      } 

    } catch (error) {
      console.error("Error deleting item:", error);
      toast.error("Failed to delete the item.");
      
      triggerToast("error", error.response.data.message, "error");
    }
  };

  return (
    <div>
      {/* Delete Button */}
      <div className="relative inline-block">
        <button
          className="my-anchor-delete relative group cursor-pointer bg-red-400 rounded-md p-1 flex items-center w-full sm:w-auto"
          onClick={() => openDialog(id_crypt)}
        >
          <TrashIcon className="h-5 w-5 text-white" />
          <Tooltip
            anchorSelect=".my-anchor-delete"
            place="top"
            className="text-xs"
            style={{ fontSize: "12px", padding: "0.3rem" }}
          >
            Delete
          </Tooltip>
        </button>
      </div>

      {isDialogOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-75 z-50 ">
          <div className="bg-white rounded-lg shadow-lg p-6 w-[90%] sm:w-[80%] md:w-[60%] lg:w-[50%] max-w-[600px] grid gap-6">
            {/* Modal Header - Responsive Design */}

            <div className="grid grid-cols-1 sm:grid-cols-2 items-center">
              <div className="flex flex-col col-span-2 sm:flex-row sm:items-start sm:space-x-4 text-center sm:text-left">
                {/* Icon */}
                <span className="flex items-center justify-center p-2 rounded-full bg-red-100 mx-auto sm:mx-0">
                  <ExclamationCircleIcon className="h-6 w-6 text-red-600" />
                </span>

                {/* Text */}
                <div className="mt-3 sm:mt-0">
                  <h2 className="text-md font-semibold text-gray-800">
                    Delete Confirmation
                  </h2>
                  <p className="text-sm text-gray-600">
                    Are you sure you want to delete this?
                  </p>
                </div>
              </div>

              {/* Close Icon (Hidden in Small Devices) */}
              {/* <div className="hidden sm:block text-right">
            <XMarkIcon
              className="h-6 w-6 text-red-600 cursor-pointer border rounded p-1 inline-block"
              onClick={closeDialog}
            />
          </div> */}
            </div>

            {/* Buttons - Always at the Bottom */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:flex sm:justify-end">
              <button
                onClick={closeDialog}
                className="w-full sm:w-auto px-4 py-2 bg-gray-200 text-gray-700 rounded hover:bg-gray-300"
              >
                Cancel
              </button>
              <button
                onClick={handleDeleteForTask}
                className="w-full sm:w-auto px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}

      {dialogForTransaction && (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-75 z-50">
          <div className="bg-white rounded-lg shadow-lg p-6 w-[90%] sm:w-[80%] md:w-[60%] lg:w-[50%] max-w-[600px] grid gap-6">
            {/* Modal Header - Responsive Design */}
            <div className="grid grid-cols-1 sm:grid-cols-2 items-center">
              <div className="flex flex-col sm:flex-row items-center sm:space-x-4">
                {/* Icon (Centered in Small Screens) */}
                <span className="flex items-center justify-center p-2 rounded-full bg-red-100">
                  <ExclamationCircleIcon className="h-6 w-6 text-red-600" />
                </span>

                {/* Text (Stacked in Small Screens) */}
                <div className="text-center grid grid-cols-1 sm:text-left mt-3 sm:mt-0 w-full">
                  <h2 className="text-lg font-bold text-gray-800">
                    Delete Confirmation
                  </h2>
                  <div className="w-full overflow-x-auto sm:overflow-visible mt-4 sm:mt-2">
                    {errorMessage}
                  </div>
                </div>
              </div>
            </div>

            {/* Buttons - Always at the Bottom */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:flex sm:justify-end">
              <button
                onClick={() => setDialogForTransaction(false)}
                className="w-full sm:w-auto px-4 py-2 bg-gray-200 text-gray-700 rounded hover:bg-gray-300"
              >
                Cancel
              </button>
              <button
                onClick={() => setDialogForTransaction(false)}
                className="w-full sm:w-auto px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
              >
                Ok
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default DeleteConfirmation;
